import { AnimationListLayout } from './AnimationListLayout';
import { ListBase } from 'react-admin';

export const AnimationList = () => {
    return (
        <ListBase
            resource="animation"
            perPage={25}
            sort={{ field: 'name', order: 'ASC' }}
        >
            <AnimationListLayout />
        </ListBase>
    );
};
